import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { ConversionsProducts } from '@components/ConversionsProducts';
import { getClientLocale, I18NProvider } from '@utils/i18n';
import apolloWrapper from '@hoc/apolloWrapper';
import { MainPageAnimatedBannerContainer } from '@containers/MainPageAnimatedBanner';
import { ViewedProductsMainSection } from '@components/ViewedProductsMainSection';
import { LayoutContainer } from '@ui/LayoutContainer';
import { IndexActionBannerController } from '@components/IndexActionBannerController';
import { MainCities } from '@components/MainCities';

import { initGoToDetailEvent } from '../catalog/analytics';
import { renderProductRating } from '../global/ProductRating';

import MainBannerContainer from './Containers/MainBanner';

const { lang, routerBasename } = getClientLocale();

const mainSlider = document.querySelector('#main-slider');

if (mainSlider) {
  const root = createRoot(mainSlider);

  root.render(
    <MainBannerContainer />,
  );
}

const appsPromotionContainer = document.querySelector('.js-main-apps-promotion-banner');
const MainAppsPromotionBannerComponent = apolloWrapper(
  MainPageAnimatedBannerContainer,
);

if (appsPromotionContainer) {
  const root = createRoot(appsPromotionContainer);

  root.render(
    <BrowserRouter basename={routerBasename}>
      <I18NProvider lang={lang}>
        {
          () => <MainAppsPromotionBannerComponent />
        }
      </I18NProvider>
    </BrowserRouter>,
  );
}

const conversionsProductsBlock = document.querySelector('.js-conversions-products');

const ConversionsProductsApollo = apolloWrapper(
  ConversionsProducts,
);

if (conversionsProductsBlock) {
  const root = createRoot(conversionsProductsBlock);

  root.render(
    <BrowserRouter basename={routerBasename}>
      <I18NProvider lang={lang}>
        {
          () => <ConversionsProductsApollo />
        }
      </I18NProvider>
    </BrowserRouter>,
  );
}

const tabs = document.querySelectorAll('.js-popular-categories-tab');
const contents = document.querySelectorAll('.js-popular-categories-content');

const tabsArr = Array.from(tabs) as HTMLLIElement[];
const contentsArr = Array.from(contents) as HTMLLIElement[];

if (tabsArr.length) {
  tabsArr.forEach((tabElement) => {
    tabElement.addEventListener('click', () => {
      const activeTabId = tabElement.dataset.tabId;

      tabsArr.forEach((tab) => {
        const { tabId } = tab.dataset;

        if (activeTabId === tabId) {
          tab.classList.add('b-index-categories__tab_state_active');
        } else {
          tab.classList.remove('b-index-categories__tab_state_active');
        }
      });

      contentsArr.forEach((contentElement) => {
        const { tabId } = contentElement.dataset;

        if (activeTabId === tabId) {
          contentElement.classList.remove('b-index-categories_state_hidden');
        } else {
          contentElement.classList.add('b-index-categories_state_hidden');
        }
      });
    });
  });
}

renderProductRating();

initGoToDetailEvent();

const jsUnpaidOrders = document.querySelector('#js-unpaid-orders');

const IndexActionBannerControllerWithApollo = apolloWrapper(IndexActionBannerController);
if (jsUnpaidOrders) {
  const root = createRoot(jsUnpaidOrders);

  root.render(
    <BrowserRouter basename={routerBasename}>
      <I18NProvider lang={lang}>
        {
          () => (
            <LayoutContainer>
              <IndexActionBannerControllerWithApollo />
            </LayoutContainer>
          )
        }
      </I18NProvider>
    </BrowserRouter>,
  );
}

const container = document.querySelector('.js-main-viewed-products');

const ViewedProducts = apolloWrapper(ViewedProductsMainSection);

if (container) {
  const root = createRoot(container);

  root.render(
    <BrowserRouter basename={routerBasename}>
      <I18NProvider lang={lang}>
        {
          () => (
            <ViewedProducts />
          )
        }
      </I18NProvider>
    </BrowserRouter>,
  );
}

const mainCitiesContainer = document.querySelector('.js-main-cities');

if (mainCitiesContainer) {
  const root = createRoot(mainCitiesContainer);

  root.render(
    <BrowserRouter basename={routerBasename}>
      <I18NProvider lang={lang}>
        {
          () => (
            <MainCities />
          )
        }
      </I18NProvider>
    </BrowserRouter>,
  );
}

